import { Title } from '@mantine/core';
import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';
import type { PropsWithChildren } from 'react';

import styleIdentifiers from './PaymentPlanForm.module.scss';

const styles = classNames.bind(styleIdentifiers);

type PaymentPlanFormWrapperProps = {};

export const PaymentPlanFormWrapper = ({
  children,
}: PropsWithChildren<PaymentPlanFormWrapperProps>) => {
  const { t } = useTranslation();

  return (
    <div className={styles('payment-plan-form')}>
      <div className={styles('head')}>
        <div>
          <Title order={3}>{t(i18nKeys.FORM.PAYMENT_PLAN.EDIT.TITLE)}</Title>
          <p className={styles('subhead')}>{t(i18nKeys.FORM.PAYMENT_PLAN.EDIT.WARNING)}</p>
        </div>
      </div>
      {children}
    </div>
  );
};
